import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/range.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

const bem = HoneyBem.init('range', styles);
const RangeSteps = _ref => {
  let {
    id,
    min,
    max,
    step,
    value,
    endValue
  } = _ref;
  const buildSteps = () => {
    const stepList = [];
    for (let i = min; i <= max; i += step) {
      const isActive = endValue > 0 ? i >= value && i <= endValue : i <= value;
      stepList.push( /*#__PURE__*/React__default__default.createElement("span", {
        className: bem.e('step', {
          active: isActive
        }),
        key: i
      }, i));
    }
    return stepList;
  };
  return /*#__PURE__*/React__default__default.createElement("div", {
    id: id,
    role: "presentation",
    "aria-hidden": "true",
    className: bem.e('steps')
  }, buildSteps());
};
RangeSteps.displayName = 'RangeSteps';
RangeSteps.defaultProps = {
  value: 0,
  endValue: 0
};
RangeSteps.propTypes = {
  /** Parent range ID that is used to bind the steplist to the range input */
  id: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
  /** Maximum value for the range */
  max: PropTypes__default.number.isRequired,
  /** Minimum value for the range */
  min: PropTypes__default.number.isRequired,
  /** Increment/decrement step */
  step: PropTypes__default.number.isRequired,
  /** Range value or Range Start Value */
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  /** Range End Value */
  endValue: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number])
};
var RangeSteps$1 = Injecss(RangeSteps, styles);

export { RangeSteps$1 as default };
